import {
  Component,
  OnInit,
  Input,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
  selector: "data-loader",
  templateUrl: "./data-loader.component.html",
  styleUrls: ["./data-loader.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DataLoaderComponent {
  @Input() showDataLoader;
  @Input() msg;
}
